import React, { useEffect, useState } from "react";
import { Container } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Button, FloatingLabel, Form, Row, Col, Alert, InputGroup, Offcanvas, Spinner, Modal } from 'react-bootstrap';
import { dbSendVerificationCode, dbCheckVerificationCode } from "../utils/db-functions";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCheckCircle } from '@fortawesome/free-solid-svg-icons';

// import imageLoggedIn from "../data/images/phone-verification-background-logged-in.png";

import './phoneVerification.scss';

export default function PhoneVerification() {
	const location = useLocation();
	const navigate = useNavigate();
	const userLoggedIn = useSelector((state) => state.user.isLoggedIn);
	const user = useSelector((state) => state.user.data);

	const [step, setStep] = useState(1);
	const [phone, setPhone] = useState(user?.phone || '');
	const [code, setCode] = useState('');
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [show, setShow] = useState(false);

	const formatNumber = (value) => {
		// returns: "x", "xx", "xxx"
		if (value.length < 4) return value;

		// returns: "(xxx)", "(xxx) x", "(xxx) xx", "(xxx) xxx",
		if (value.length < 7) return `(${value.slice(0, 3)}) ${value.slice(3)}`;

		// returns: "(xxx) xxx-", (xxx) xxx-x", "(xxx) xxx-xx", "(xxx) xxx-xxx", "(xxx) xxx-xxxx"
		return `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6, 10)}`;
	}

	// TO DO: Country based phone
	const sendVerificationCode = async () => {
		// const fullPhone = '+1' + phone;
		setLoading(true);

		try {
			const res = await dbSendVerificationCode({ phone: phone });

			if (res?.data?.status === 'pending') {
				setError(false);
				setStep(2);
				setLoading(false);
				return;
			}

			if (res?.data?.status === 'already verified') {
				setError('This phone has already been verified. Please, try another phone.');
				setLoading(false);
				return;
			}

			if (res?.data?.status === 'phone does not match') {
				setError("This phone does not match with the phone in your profile.");
				setLoading(false);
				return;
			}

			if (res?.data?.status === 'bonus exists') {
				setError('You already have a bonus. Please refresh the page.');
				setLoading(false);
				return;
			}

			setError('Something went wrong. Please, check your phone and try again.');
			setLoading(false);
		} catch (error) {
			console.log(error);
			setError('Something went wrong. Please, check your phone and try again.');
			setLoading(false);
		}
	}

	const checkVerificationCode = async () => {
		//const fullPhone = '+1' + phone;
		setLoading(true);

		try {
			const res = await dbCheckVerificationCode({ phone: phone, code: code });

			if (res?.data?.status === 'approved') {
				navigate(0)
				return;
			}

			if (res?.data?.status === 'bonus exists') {
				setError('You already have a bonus. Please refresh the page.');
				setLoading(false);
				return;
			}

			setError('Something went wrong. Please, check your phone and try again.');
			setLoading(false);
		} catch (error) {
			console.log(error);
			setError('Something went wrong. Please, check your phone and try again.');
			setLoading(false);
		}
	}

	// useEffect(() => {
	// 	return () => { }
	// })

	return (
		<Container fluid="lg" className="section-margin verify-phone-section">
			{/* {
				!userLoggedIn && (
					<Link to={`${location.pathname}?register`} className="verify-phone-container logged-out">
						<div className="verify-phone-content">
							<div>
								<span className="verify-phone-badge mb-0">NO DEPOSIT REQUIRED</span>
								<h2 className="title mb-2">10 FREE SPINS</h2>
								<p className="mb-0 verify-phone-cta">Claim now</p>
							</div>
						</div>
					</Link>
				)
			} */}

			{
				!userLoggedIn && (
					<div className="verify-phone-container">
						<div className="verify-phone-image-wrapper">
							<img src="https://cherryspins.b-cdn.net/bonuses/no-deposit-10FS-7-monkeys.png" className="verify-phone-image" />
						</div>

						<div className="verify-phone-content">
							<div className="text-center text-md-start">
								{/* <span className="verify-phone-badge mb-0">FREE SPINS</span> */}
								<h2 className="subtitle white-100 mb-2">Get <span className="personalized-gold">10 free spins</span> with no deposit&nbsp;required!</h2>
								<p className="mb-0">Limited time only! Receive 10 free spins after completing your registration.</p>
							</div>
							<div className="verify-phone-buttons logged-out">
								<Link to={`${location.pathname}?register`} className="btn-gold">Claim now</Link>
							</div>
						</div>
					</div>
				)
			}

			{
				userLoggedIn && !user.phoneVerified && user.depositsMade === 0 && (
					<>
						<div className="verify-phone-container">
							<div className="verify-phone-image-wrapper">
								<img src="https://cherryspins.b-cdn.net/bonuses/no-deposit-10FS-7-monkeys.png" className="verify-phone-image" />
							</div>

							<div className="verify-phone-content">
								{
									step === 1 && (
										<>
											<div>
												<h2 className="subtitle white-100 mb-3 mb-md-2">Confirm your phone and get <span className="personalized-gold">10 free spins</span>!</h2>
												<InputGroup id="phone" name="phone" className="verify-phone-field mb-0">
													{/* <InputGroup.Text>
													+1
												</InputGroup.Text> */}
													<Form.Control
														type="text"
														maxLength="14"
														//value={formatNumber(phone)}
														value={phone}
														placeholder="Enter your mobile phone"
														isValid={phone.length > 7}
														onChange={e => setPhone(e.target.value)} />
												</InputGroup>
												{
													error && (
														<p className="mt-2 mb-0 verify-phone-error">{error}</p>
													)
												}
												<p className="mb-0 mt-2">Example: +15017122661</p>
											</div>

											<div className="verify-phone-buttons">
												<Button className="btn-gold" onClick={sendVerificationCode}>
													{
														loading ? (
															<>
																<Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />&nbsp;&nbsp;Confirm and claim
															</>
														) : (<>Confirm and claim</>)
													}
												</Button>
											</div>
										</>
									)
								}

								{
									step === 2 && (
										<>
											<div>
												<h2 className="subtitle white-100 mb-3">Enter confirmation code</h2>
												<InputGroup id="code" name="code" className="verify-code-field">
													<Form.Control
														type="text"
														maxLength="6"
														value={code}
														placeholder="Code"
														onChange={e => setCode(e.target.value)} />
												</InputGroup>
												{
													error && (
														<p className="mt-2 mb-0 verify-phone-error">{error}</p>
													)
												}
											</div>

											<div className="verify-phone-buttons">
												<Button className="btn-gold" onClick={checkVerificationCode}>
													{
														loading ? (
															<>
																<Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />&nbsp;&nbsp;Confirm
															</>
														) : (<>Confirm</>)
													}
												</Button>
												<Button className="btn-secondary" onClick={() => {
													setStep(1)
													setError(false)
												}}>
													Try again
												</Button>
											</div>
										</>
									)
								}

							</div>
						</div>

						{/* <p className="ms-2 mt-2 disabled-text" style={{ fontSize: "12px" }}>
							<FontAwesomeIcon icon={faCheckCircle} />  By verifying your phone number you agree to occasionally receive promotional messages from Cherry Spins website.&nbsp;
							<a href="javascript:void" style={{fontSize: "12px"}} className="disabled-text" onClick={() => setShow(true)}>Learn more</a>.
						</p> */}

						{/* <TermsAndConditionsModal {...{ show, handleClose: () => { setShow(false) } }} /> */}
					</>
				)
			}
		</Container>
	);
}


function TermsAndConditionsModal({ show, handleClose, }) {
	return (
		<Modal show={show} onHide={handleClose} centered>
			<Modal.Header closeButton>
				<Modal.Title>Terms and conditions</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<p>By completing and submitting this form, and by opting in for SMS notifications, you hereby grant your explicit consent to receive occasional marketing text messages pertaining to our latest promotions, exclusive offers, and relevant updates. You acknowledge that these messages may be sent to the mobile number provided during the sign-up process.</p>

				<p>We respect your privacy and offer you the option to unsubscribe from these text messages at any time. To opt-out, simply click on the unsubscribe link (where available) or send us an email with your request.</p>

				<p>For a comprehensive understanding of how your information is handled, please refer to our <a href="https://www.cherryspins.support/privacy-policy" target="_blank">Privacy Policy</a> and familiarize yourself with our <a href="https://www.cherryspins.support/terms-and-conditions" target="_blank">Terms</a>. Your continued engagement with our SMS service implies acceptance of these terms and conditions.</p>

				<p>Thank you for choosing to stay connected with us. We look forward to keeping you informed about our exciting offers and promotions.</p>
			</Modal.Body>
		</Modal>
	)
}